import axios from "axios"

const controller = "/almacen"

const AlmacenService = {
    
    buscar: async (almacen) => {
        const { data } = await axios.post(`${controller}/buscar`, {
            almacen
        })
        return data
    },

    obtenerxProyecto: async (pryId) => {
        const { data } = await axios.post(`${controller}/obtenerxProyecto`, {
            pryId
        })
        return data
    },

    buscarRapido: async (almacen) => {
        const { data } = await axios.post(`${controller}/buscarRapido`, {
            almacen
        })
        return data
    },
}


export default AlmacenService